import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileTxt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15.75 8.25H18V17.25H19.5V8.25H21.75V6.75H15.75V8.25ZM15 6.75H13.5L12 11.25L10.5 6.75H9L11.0625 12L9 17.25H10.5L12 12.75L13.5 17.25H15L12.9375 12L15 6.75ZM2.25 8.25H4.5V17.25H6V8.25H8.25V6.75H2.25V8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileTxt.vue"]]);
